import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { findIconDefinition } from '@fortawesome/fontawesome-svg-core'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

library.add(fas, far, fab)

const FaIcon = (props) => {
  const { icon, usePro, ...iconProps } = props
  if (!icon) { return null }
  const regular = icon.endsWith('-o')
  const iconName = regular ? icon.slice(0, -2) : icon

  if (usePro) {
    // Pro is only available as a webfont (font_awesome_pro override), not as
    // SVG packages, so render an <i> instead of FontAwesomeIcon
    const { className, ...proProps } = iconProps
    const proClassName = [ regular ? 'fa-regular' : 'fa-solid', `fa-${iconName}`, className ].filter(Boolean).join(' ')
    return (
      <i className={proClassName} aria-hidden='true' { ...proProps } />
    )
  }

  const prefix = regular ? 'far' : 'fas'
  const finalIconName = findIconDefinition({ prefix: prefix, iconName: iconName })

  return (
    <FontAwesomeIcon icon={finalIconName} { ...iconProps } />
  )
}


FaIcon.propTypes = {
  // Name of the icon
  icon: PropTypes.string,
  // Render through the Font Awesome Pro webfont instead of the free SVG set
  usePro: PropTypes.bool,
}

FaIcon.defaultProps = {
  usePro: false,
}


export default FaIcon
